import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString } from '../../../../../utils/stringify-utils';
import { LAYER_NAME_PROP, Z_ORDER_PROP } from '../../common/config/common-prop-names';
import { FreeDrawNodeCreateProps } from '../models/free-draw-node-create-props';
import { FreeDrawNode } from '../models/free-draw-node.model';
import { bringToFront } from './../../../../../utils/bring-to-front-back/bring-to-front';

export const createFreeDrawNode = (
  diagram: go.Diagram,
  { borderWidth, geometryString, categoryName, defaultBorderColor, defaultLocked, location }: FreeDrawNodeCreateProps,
) => {
  const key = uuid.v4();

  diagram.commit(() =>
    diagram.model.addNodeData(
      new FreeDrawNode(
        key,
        categoryName,
        geometryString,
        defaultBorderColor,
        borderWidth,
        defaultLocked,
        getPointString(location.x, location.y),
      ),
    ),
  );

  const node = diagram.findNodeForKey(key);
  if (node) {
    bringToFront(node, Z_ORDER_PROP, LAYER_NAME_PROP);
  }

  return node;
};
